import { render, staticRenderFns } from "./GaugeCategory.vue?vue&type=template&id=505f33b9&scoped=true&"
import script from "./GaugeCategory.vue?vue&type=script&lang=js&"
export * from "./GaugeCategory.vue?vue&type=script&lang=js&"
import style0 from "./GaugeCategory.vue?vue&type=style&index=0&id=505f33b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505f33b9",
  null
  
)

export default component.exports